const normalizeThreadTitle = (value) => {
  return String(value || '')
    .trim()
    .slice(0, 200);
};

export default normalizeThreadTitle;
